import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense, useState } from 'react';

import { HeroSection } from '@/components/landing/HeroSection';
import { IntroductionSection } from '@/components/landing/IntroductionSection';
import { DEFAULT_LOCALE } from '~/utils/i18n';


// Lazy load all sections except Hero (critical above-fold)
const ProductsSection = lazy(() => import('@/components/landing/ProductsSection').then(m => ({ default: m.ProductsSection })));
const NewsroomSection = lazy(() => import('@/components/landing/NewsroomSection').then(m => ({ default: m.NewsroomSection })));
const CTASection = lazy(() => import('@/components/landing/CTASection').then(m => ({ default: m.CTASection })));

const LandingPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  return (
    <div className="bg-black min-h-full w-full mx-auto">
      <HeroSection />
      <IntroductionSection />
      <Suspense fallback={null}>
        <ProductsSection />
        <NewsroomSection
          currentSlide={currentSlide}
          onSlideChange={setCurrentSlide}
        />
        <CTASection />
      </Suspense>
    </div>
  );
};

export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => ({
    ...context,
    locale: DEFAULT_LOCALE,
  }),
  component: LandingPage,
});

